import { Component, Input, OnInit } from '@angular/core';

export enum NiButtonView {
    Default = 'default',
    Accent = 'accent',
    Blank = 'blank',
    Error = 'error',
    Info = 'info',
    Success = 'success',
    Warning = 'warning',
}
export enum NiButtonSize {
    Small = 'small',
    Default = 'default',
    Large = 'large',
}
export enum NiButtonAlign {
    Left = 'left',
    Center = 'center',
    Right = 'right',
}
export enum NiButtonPadding {
    Default = 'default',
    Padding = 'padding',
}

@Component({
    host: {
        '[class.ni-btn-accent]': 'view === "accent"',
        '[class.ni-btn-blank]': 'view === "blank"',
        '[class.ni-btn-block]': 'block',
        '[class.ni-btn-customButton]': 'padding === "padding"',
        '[class.ni-btn-default]': 'view === "default"',
        '[class.ni-btn-disabled]': 'disabled',
        '[class.ni-btn-error]': 'view === "error"',
        '[class.ni-btn-gradient]': 'gradient',
        '[class.ni-btn-icon-animation]': 'iconAnimation',
        '[class.ni-btn-info]': 'view === "info"',
        '[class.ni-btn-large]': 'size === "large"',
        '[class.ni-btn-left]': 'align === "left"',
        '[class.ni-btn-outline]': 'outline',
        '[class.ni-btn-right]': 'align === "right"',
        '[class.ni-btn-small]': 'size === "small"',
        '[class.ni-btn-success]': 'view === "success"',
        '[class.ni-btn-warning]': 'view === "warning"',
        '[class.ni-btn]': 'true',
        '[style.border-radius]': 'shape',
    },
    selector: '[ni-button]',
    styleUrls: ['./ni-button.component.scss'],
    templateUrl: './ni-button.component.html',
})
export class NiButtonComponent implements OnInit {
    @Input() block = false;
    @Input() gradient = false;
    @Input() disabled = false;
    @Input() outline = false;
    @Input() lineStyle: string;
    @Input() align: NiButtonAlign | string = NiButtonAlign.Center;
    @Input() size: NiButtonSize | string = NiButtonSize.Default;
    @Input() view: NiButtonView | string = NiButtonView.Default;
    @Input() padding: NiButtonPadding | string = NiButtonPadding.Default;
    @Input() shape: number | string;
    @Input() beforeIcon: string;
    @Input() afterIcon: string;
    @Input() iconAnimation = false;

    constructor() {}

    ngOnInit() {}
}
